import React from 'react'
import { PortalStep } from './Enum'
import BtnSelect from '../../Shared/Buttons/BtnSelect';
import {setCurrentStep} from './OrganizationPortalSlice';
import { connect } from 'react-redux';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';


const OrgFooterButtons =({setCurrentStep, steps ,onContinue,error ,btnText, userDetails}) => {

  const enumValues = Object.values(PortalStep);
  const currentIndex = enumValues.indexOf(steps.current);

  let nextStep = currentIndex < enumValues.length - 1
    ? enumValues[currentIndex + 1]
    : steps.current;

  if (steps.current === PortalStep.DistributionCenter && userDetails?.actionType !== 'activate') {
    nextStep = PortalStep.UserPaymentInfo;
  }


  const goToNextPage=async()=>{
  if(onContinue){
    var canContinue =  await onContinue();
    canContinue &&  setCurrentStep({current:nextStep, previous:steps.current});
   }
  }

  const goBack=async()=>{
    if(steps.previous ==PortalStep.OrderSummary){
      if(onContinue){
        var canContinue =  await onContinue();
        canContinue &&  setCurrentStep({current:PortalStep.OrderSummary });
       }
    }
    else{
       setCurrentStep({current:steps.previous, previous:enumValues[currentIndex -2]})
    }
  }

  return (
    <div className='Footer_Buttons'>
      <div className='btnContainer'>
      {steps.previous ==PortalStep.OrderSummary ?
         <BtnSubmit text={'חזרה לעמוד סיכום'}  onclick={() => goBack()} />
       :<>
        { error && <span className='error-msg'>{error}</span>}
        <BtnSubmit text={btnText ? btnText:'בחרתי , אפשר להתקדם'}  onclick={()=> goToNextPage()} />
        <BtnSelect text={'חזרה למסך הקודם'} onClick={() => goBack()} />
        </>}
      </div>
    </div>
  );
}


const mapStateToProps = (state) => ({
  steps: state.organizationPortal.steps,
  userDetails: state.organizationPortal.userDetails,
});

const mapDispatchToProps = {
  setCurrentStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgFooterButtons);
